module.exports = __webpack_public_path__ + "img/menu-safety.a5dd48ab.svg";